// PDF download utility — uses @react-pdf/renderer for PDF generation.
// Accepts a canonical InvoiceDisplayModel (from invoiceViewModel.js) and a filename.
import { pdf } from "@react-pdf/renderer";
import React from "react";
import InvoiceDocumentPdf from "@/components/InvoiceDocumentPdf";

/**
 * Generate and trigger download of an invoice PDF.
 *
 * @param {object} model    — InvoiceDisplayModel from buildFromFormState / buildFromApiResponse
 * @param {string} filename — e.g. "INV-0042_Original.pdf"
 */
export async function downloadInvoicePDF(model, filename = "invoice.pdf") {
  if (!model) throw new Error("Invoice model is required");

  try {
    const blob = await pdf(<InvoiceDocumentPdf model={model} />).toBlob();
    const url = window.URL.createObjectURL(blob);
    const a = window.document.createElement("a");
    a.href = url;
    a.download = filename;
    window.document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    window.document.body.removeChild(a);
  } catch (error) {
    console.error("PDF generation error:", error);
    throw error;
  }
}
